<section class="section-planos zoom-scope" [ngStyle]="styles" *ngIf="items.length > 0">

  <div class="d-flex title">
    <img class="img-logo" src="/assets/imagens/ICONE SV ROXO.svg">
    <h1 style="color: #3b0058 !important;"><b>PLANOS</b></h1>
  </div>

  <div class="d-block info ">
    <span>Nos planos com acesso livre você <b>paga apenas a mensalidade</b>, e poderá <b>ir para o jogo sempre que quiser</b>, mediante check-in e disponibilidade de lugares no setor de seu plano.</span>
    <br>
    <br>
    <span>No plano com recarga você paga a mensalidade, mas para assistir aos jogos precisa <b>adquirir uma recarga de ingresso POR JOGO, com valor fixo e acessível.</b></span>
  </div>



  <div class="plans-wrapper" #carouselContainer>
        <div *ngFor="let item of items" class="plan-container">
      <div class="card-plan" [style.background]="'url(' + item.src + ')'">
        <div class="row h-100">

          <!-- COLUNA ESQUERDA -->
          <div class="col-6 left">
            <span class="plan-title">{{ item.title }}</span>

            <span class="plan-price"><b>{{ item.valor }}</b></span>

            <span class="plan-payment">
              {{ item.periodo }}
            </span>

            <button class="btn-associar" (click)="onSelectPlan(item.planId)">
              ASSOCIAR
            </button>
          </div>

          <!-- COLUNA DIREITA -->
          <div class="col-6 right">
            <div class="benefit" *ngFor="let benefit of item.enableItems">
              {{ benefit }}
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

   <div class="carousel-controls" *ngIf="items.length > 1">
    <button class="carousel-btn prev" (click)="scrollCarousel('prev')">
      <i class="bi bi-chevron-left"></i>
    </button>
    <button class="carousel-btn next" (click)="scrollCarousel('next')">
      <i class="bi bi-chevron-right"></i>
    </button>
  </div>
</section>

    <!-- <div class="container wrapper-planos py-4" [ngClass]="classesAlign">
        <div class="wrapper-planos pb-3" [ngClass]="classesAlign">
            <h1 class="title-planos">{{title}}</h1>
            <p *ngIf="showSubtitle" class="subtitle-planos">{{subtitle}}</p>
        </div>
        <app-carousel-plans
            [items]="items"
            [styles]="styles"
            [defaultButtonOptions]="buttonOptionsCard"
            [highlightButtonOptions]="buttonOptionsCardSpecial"
            (carouselResponse)="carouselResponse($event)">
        </app-carousel-plans>
    </div> -->

<!-- Modal de Seleção de Planos -->
<app-modal-plan-selection
    [isVisible]="showModal"
    [categories]="modalCategories"
    [initialCategoryIndex]="selectedCategoryIndex"
    [operationType]="'NEW'"
    (close)="onCloseModal()"
    (selectPlan)="onSelectPlan($event)">
</app-modal-plan-selection>
